import * as React from 'react';
import {useDispatch} from 'react-redux';
import {checkCode} from '../../../redux/actions/login';
import {loginSlice} from '../../../redux/reducers/login';
import {RequestedOperationType} from '../../../shared/models/api';
import {ServerValidationError} from '../../../shared/models/serverValidationError';
import {storage, StorageKeys} from '../../../shared/storage';
import {ConfirmationChangePassword} from './changePassword';
import {ConfirmationInvalidLink} from './invalidLink';

interface ConfirmationRoute {
  params: {
    op: string;
    code: string;
    card: string; // not used yet, but comes with query string params
  };
}

export const Confirmation: React.FC<{route: ConfirmationRoute}> = ({route: {params: {op = '', code = ''} = {}}}) => {
  const dispatch = useDispatch();
  const errorMessage = React.useRef(`Возможно, Вы запросили новое\n письмо или ссылка устарела.`);
  const [isCodeChecked, setCodeChecked] = React.useState<boolean | null>(null);

  React.useEffect(() => {
    if (typeof code !== 'string' || !code.length || op !== 'restorePassEmail') {
      setCodeChecked(false);
    } else {
      (async () => {
        try {
          const codeId = await storage.getItem(StorageKeys.recoveryCodeId);
          if (codeId) {
            dispatch(loginSlice.actions.setSendCodeResponse({codeId}));
            await dispatch(checkCode(code, '', RequestedOperationType.SetPasswordConfirmation));
            setCodeChecked(true);
          } else {
            setCodeChecked(false);
          }
        } catch (e) {
          const error = e as ServerValidationError;
          if (error?.data?.[0]?.message) {
            errorMessage.current = error.data[0].message;
          }
          setCodeChecked(false);
        }
      })();
    }
  }, [op, code]);

  if (isCodeChecked === null) {
    return null;
  }

  return isCodeChecked ? (
    <ConfirmationChangePassword code={code} />
  ) : (
    <ConfirmationInvalidLink message={errorMessage.current} />
  );
};
